import moment from 'moment-timezone';
import { deliveryDocumentFilename } from './constants';
import { isHauler, isProcessor } from '../../../../../utils';

export const FOLDER_FACETS = ['date', 'processor', 'hauler', 'route'];

export const availableFacets = () => FOLDER_FACETS.filter((facet) => !(facet === 'hauler' && isHauler()) && !(facet === 'processor' && isProcessor()));

export const facetLabel = (facet, localization) => ({ date: 'Date', processor: localization.general.processor_singular, hauler: localization.general.hauling_singular, route: 'Route' }[facet]);

export const sampleFolders = (row, localization) => {
    if (!row) {
        return {
            date: '2026-10-21',
            processor: `${localization.general.processor_singular} name`,
            hauler: `${localization.general.hauling_singular} name`,
            route: 'Route name',
            filename: 'LT-1234 - Delivery Report v1 - 2026-10-21.pdf',
        };
    }
    return {
        date: moment(row.created_at).format('YYYY-MM-DD'),
        processor: row.processor?.name || 'No Processor',
        hauler: row.hauling_id?.name || 'No Hauler',
        route: row.route_id?.name || row.route_number || 'No Route',
        filename: deliveryDocumentFilename(row),
    };
};
